<template>
  <div class="container orders-page">
    <v-head></v-head>
    <v-left current="orders" active="diy"></v-left>
    <div>
      <h1>订单图库</h1>
      <div class="filter-dic clearfix">
        <div class="fl">
          <el-select
            v-model="filter.app_id"
            placeholder="应用"
            size="small"
            class="w160"
            @change="search"
            @clear="search"
            clearable
          >
            <el-option
              v-for="item in $store.state.public.cfg.apps_options"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="filter.order_status"
            placeholder="订单状态"
            clearable
            @clear="search"
            @change="search"
            size="small"
            class="w160"
          >
            <el-option
              v-for="item in statics_orders"
              :key="item.status"
              :label="item.label + '(' + item.count  + ')'"
              :value="item.status"
            ></el-option>
          </el-select>
          <el-date-picker
            size="small"
            style="width: 256px"
            v-model="filter.time_range"
            clearable
            @change="search"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-input
            size="small"
            v-model="filter.order_no"
            placeholder="订单号"
            clearable
            @clear="search"
            @change="search"
            style="width: 133px"
            class="w400 input-with-select"
          >
          </el-input>
          <el-input
            size="small"
            v-model="filter.shopify_order_number"
            placeholder="Shopify编号"
            clearable
            @clear="search"
            @change="search"
            style="width: 133px"
            class="w400 input-with-select"
          >
          </el-input>
          <el-input
            size="small"
            v-model="filter.keyword"
            placeholder="搜订单号、工厂单号、备注"
            clearable
            @clear="search"
            @change="search"
            style="width: 300px"
            class="w400 input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </div>
        <div class="fr">
          <el-pagination
            class="my-page"
            style="margin-top: 0;padding-top:0;"
            background
            :page-size="list_data.size"
            :page-sizes="[24, 30, 40, 50, 100]"
            layout="total, prev, pager, next"
            @current-change="changePage"
            :total="list_data.total"
          >
          </el-pagination>
        </div>
      </div>
      <div>
        <div>
          <ul v-loading="loading" style="padding-bottom: 100px">
            <li
              class="create-li-2 fl"
              v-for="(order, index) in list_data.list"
              :key="index"
            >
              <div class="order-package relative">
                <ul class="clearfix">
                  <li v-for="(item, index_item) in order.detail" :key="index_item" class="fl" style="height:445px;overflow:hidden;">
                    <div class="diy-dom" style="margin:0 auto;max-height:308px;overflow:hidden;">
                      <div v-if="item.diy_info" class="template-img">
                        <el-image style="width: 100%; height: 100%" :src="item.diy_info.image_diy" :preview-src-list="[item.diy_info.image_draw]"></el-image>
                      </div>
                      <div v-else-if="item.auto_design" class="template-img">
                        <el-image style="width: 100%; height: 100%" :src="item.auto_design.image_draw" :preview-src-list="[item.auto_design.image_draw]"></el-image>
                      </div>
                      <div v-else-if="item.upload_file_list_images" class="template-img">
                        <el-image 
                          v-for="(photo, index_up) in item.upload_file_list_images" 
                          :key="index_up" 
                          style="width: 100%; height: 100%" 
                          :src="photo" 
                          :preview-src-list="item.upload_file_list_images">
                          </el-image>
                      </div>
                    </div>
                    <div style="text-align: center; padding-top: 10px">
                      <div style="text-align:left;">
                        <div style="font-size:12px;">{{item.model_name}} | {{item.design_type_label}}</div>
                        <div style="font-size:12px;">{{item.sku_code}}</div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div style="position:absolute;left:0;bottom:0;right:0;background-color:#fff;z-index:2;border-top:1px solid gray;">
                  <div class="clearfix">
                    <div class="fl">
                      <span>{{ order.ctime_show }}</span>
                    </div>
                    <div class="fr">
                      <!-- <a style="margin-right:10px;color:#aaa;">detail</a> -->
                      <!-- <a target="_blank">#{{order.shopify_order_number}}</a> -->
                    </div>
                  </div>
                  <div>{{order.address_info.last_name}} {{order.address_info.first_name}}</div>
                  <div v-if="order.logistics_track_number"><a :href="order.logistics_track_link" target="_blank">{{order.logistics_track_number}}</a></div>
                  <div>
                    <el-button size="mini" class="pointer" style="margin-top:12px;margin-left:0;" v-if="order.enable_package" @click="to_create_package(order)">申请面单</el-button>
                    <el-button size="mini" class="pointer" style="margin-top:12px;margin-left:0;" v-if="order.enable_send" @click="to_send_order(order)">订单发货</el-button>
                  </div>
                </div>
              </div>
              <el-tag type="danger" style="position:absolute;top:0;right:0;z-index:2;">{{order.order_status_show}}</el-tag>
            </li>
            <li style="clear: both"></li>
          </ul>
        </div>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          :page-sizes="[24, 30, 40, 50, 100]"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
      </div>
    </div>
    <component :is="popName" :row="edit_row" :orders="edit_row"></component>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const pop_create_by_result = (resolve) => require(["@/pages/diy/templates/_pop_create_by_result"], resolve);
const pop_download_create = (resolve) => require(["@/pages/orders/create/_pop_download_create"], resolve);
const pop_create_package = (resolve) => require(["@/pages/logistics/_pop_create_package"], resolve);
export default {
  components: {
    "v-head": head,
    "v-left": left,
    pop_create_by_result,
    pop_download_create,
    pop_create_package,
  },
  data() {
    return {
      loading: false,
      popName: null,
      edit_row: null,
      filter: {
        page: 1,
        size: 50,
        platform: "",
        keyword: "",
        status: "",
        order_status: "",
        app_id: "",
        order_step: 2,
        time_range: [],
        order_no:"",
        shopify_order_number:"",
      },
      list_data: {
        size: 24,
        page: 1,
        total: 0,
        list: [],
      },
      statics_orders:[],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    changePage(e) {
      this.filter.page = e;
      this.getList();
    },
    search() {
      this.filter.page = 1;
      this.getList();
    },
    toCreate(row) {
      this.edit_row = row;
      this.popName = "pop_create_by_result";
    },
    toDownload(row) { 
      this.edit_row = row;
      this.popName = "pop_download_create";
    },
    toDownloadImg(row) { 
      this.download(row.image_diy_draw)
    },
    to_create_package(row) {
      this.edit_row = row;
      this.popName = "pop_create_package";
    },
    to_send_order(row) {
      this.$confirm('确定发货?', '发货', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("/v1/pri/orders-step/send", {order_no_list:[row.order_no]}).then((response) => {
            this.loading = false;
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getList()
            }
          });
        }).catch(() => {});
    },
    getStaticsOrders(is_loading = true) {
      this.$http.post("/v1/pri/orders/statics", this.filter).then((response) => {
        this.loading = false;
        var res = response.data;
        if (res.code == 1) {
          var statics = res.data.statics_orders;
          for (var i = 0; i < statics.length; i++) { 
            statics[i].status = statics[i].status + "";
          }
          this.statics_orders = statics;

          var exception_orders = res.data.exception_orders;
          for (var i = 0; i < exception_orders.length; i++) { 
            exception_orders[i].status = exception_orders[i].status + "";
          }
          this.exception_orders = exception_orders;
        }
      });
    },
    getList() {
      this.loading = true;
      this.$http
        .post("/v1/pri/orders/lists", this.filter)
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.list_data = res.data;
          }
        });
    },
  },
  mounted() {
    this.getStaticsOrders();
    this.getList();
  },
};
</script>
<style scoped>
.orders-page .filter-dic {
  margin-bottom: 14px;
}
.create-li-2 {
  margin: 32px 32px 0 0;
  position: relative;
  box-shadow: 2px 2px 5px #999;
  padding: 10px;
  min-width: 200px;
  box-sizing: border-box;
  text-align: center;
}
.create-li-2 .diy-dom {
  width: 156px;
  height: 310px;
  background-position: center center;
  background-size: 100% 100%;
  position: relative;
}
.create-li-2 .diy-dom img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.create-li-2 .el-icon-close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 11;
  cursor: pointer;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/orderCreate/Index.vue